<div class="modal-header">
  <div class="main-logo">
    <img src="assets/images/logo-uecko-wardrobe-configurator.svg" alt="{{ 'COMMON.APP_TITLE' | translate }}" width="102">
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'COMMON.CLOSE' | translate" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <!-- Content -->
  <div class="modal-content-body">
    <div [innerHTML]="content"></div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn-black btn-sm" (click)="closeModal()">{{ 'COMMON.CLOSE' | translate }}</button>
</div>
